import DeclaracaoSaudeInfo from './DeclaracaoSaudeInfo';

export default DeclaracaoSaudeInfo;
